import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa87d932&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fa87d932&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=fa87d932&prod&scoped=true&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=fa87d932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87d932",
  null
  
)

export default component.exports